import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_s5ZGUcx5KmzJh4-98HTuPSOMY-qqEEU",
  authDomain: "bookinindia.firebaseapp.com",
  projectId: "bookinindia",
  storageBucket: "bookinindia.firebasestorage.app",
  messagingSenderId: "366361394024",
  appId: "1:366361394024:web:e37311df804c6c0ef774dd",
  measurementId: "G-244QDV2R76"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export { db };
